'use client'

import { useRef } from 'react'

/**
 * Magnetic-Effekt: Ziel zieht sanft in Richtung Cursor. Nur innerhalb einer
 * Bounding-Box, die etwas größer ist als das Ziel (für weiches Greifen).
 */
export function Magnetic({
  children,
  strength = 0.35,
  className = '',
}: {
  children: React.ReactNode
  strength?: number
  className?: string
}) {
  const ref = useRef<HTMLSpanElement | null>(null)

  function onMove(e: React.MouseEvent<HTMLSpanElement>) {
    const el = ref.current
    if (!el) return
    const r = el.getBoundingClientRect()
    const x = e.clientX - (r.left + r.width / 2)
    const y = e.clientY - (r.top + r.height / 2)
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`
  }
  function onLeave() {
    const el = ref.current
    if (!el) return
    el.style.transform = 'translate(0,0)'
  }

  return (
    <span
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      data-magnetic
      className={className}
      style={{ transition: 'transform .35s cubic-bezier(0.16, 1, 0.3, 1)' }}
    >
      {children}
    </span>
  )
}
